import { useEffect, useState } from "react";

const THRESHOLD = 20;

export function useScrollEnd({ ref, onScrollEnd, direction = "down" }) {
	const [el, setEl] = useState(ref);

	useEffect(() => {
		updateElement(ref)
	}, [ref])

	useEffect(() => {
		if (!el) return;
		let timer = null;
		let lastY = 0;

		const onScroll = () => {
			let y = el.scrollTop;
			if (isOnEnd() && y > lastY) {
				if (timer) clearTimeout(timer);
				timer = setTimeout(() => {
					onScrollEnd?.();
				}, 150);
			}
			lastY = el.scrollTop
		};

		el.addEventListener('scroll', onScroll, { passive: true });
		return () => {
			el.removeEventListener('scroll', onScroll);
			if (timer) clearTimeout(timer);
		};
	}, [el, onScrollEnd])

	function updateElement(ref) {
		setEl(ref?.current ? ref.current : ref);
	}

	function isOnEnd() {
		return el.scrollTop + el.clientHeight >= el.scrollHeight - THRESHOLD;
	}

	return { updateElement, isOnEnd }
}